import { useGetClinicAllInfo } from 'lib/hooks/tanstack/use-getClinicInfo';
import { useClinicianContext } from 'lib/hooks/use-resolveCurrentClinicInfo';

export function useIsInImPACTClinic() {
  const clinicianContext = useClinicianContext();
  const { clinicInfo } = useGetClinicAllInfo(clinicianContext.currentClinic);
  return clinicInfo?.clinic?.crx_metadata?.leadMetadata?.leadSource === 'impact';
}
